/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Meta_TitleInputs */

const en_password_reset_meta_title = /** @type {(inputs: Password_Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset your Password on Listening.com`)
};

const es_password_reset_meta_title = /** @type {(inputs: Password_Reset_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablece tu contraseña en Listening.com`)
};

/**
* | output |
* | --- |
* | "Reset your Password on Listening.com" |
*
* @param {Password_Reset_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_meta_title = /** @type {((inputs?: Password_Reset_Meta_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Meta_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_meta_title(inputs)
	return en_password_reset_meta_title(inputs)
});